import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { DialogLayoutModule, MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { CommonValidationRendererModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { AccordionDirective, GlobalUiModule } from "@obg/ngx.ui.global";

import { DepositLimitCalculatorModule } from "../../deposit-limit-calculator/deposit-limit-calculator.module";

import { DepositLimitItemComponent } from "./deposit-limit-item/deposit-limit-item.component";
import { DepositLimitItemActionsComponent } from "./deposit-limit-item-actions/deposit-limit-item-actions.component";
import { MultiDepositFormComponent } from "./multi-deposit-form/multi-deposit-form.component";
import { MultiDepositLimitDialogContainer } from "./multi-deposit-limit-dialog/multi-deposit-limit-dialog.container";
import { MultiDepositLimitContainer } from "./multi-deposit-limit.container";

const DIRECTIVES: any[] = [
	MultiDepositLimitContainer,
	MultiDepositLimitDialogContainer,
	DepositLimitItemComponent,
	DepositLimitItemActionsComponent,
	MultiDepositFormComponent,
];

@NgModule({
	imports: [
		CoreUiModule,
		MatCardModule,
		GlobalUiModule,
		GlobalModule,
		MatInputModule,
		CommonModule,
		MatFormFieldModule,
		CoreContentModule,
		CoreModule,
		MatCoreModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		CommonValidationRendererModule,
		DepositLimitCalculatorModule,
	],
	declarations: DIRECTIVES,
	exports: DIRECTIVES,
	providers: [AccordionDirective],
	bootstrap: [MultiDepositLimitContainer],
})
export class MultiDepositLimitModule {
	constructor(
		resolver: ComponentFactoryResolver,
		componentFactoryService: ComponentFactoryService,
		private componentFactoryResolver: ComponentFactoryResolver
	) {
		componentFactoryService.registerLazyLoadedResolver(resolver, MultiDepositLimitDialogContainer);
	}

	getComponent() {
		return this.componentFactoryResolver.resolveComponentFactory(MultiDepositLimitContainer);
	}
}
